@if (entity === "melaList") {
    @if (columnDetails?.field === "nomination_window") {
        @if (rowData?.nomination_window === "yes") {
            <div class="nominationWindow open-width">
                <p class="nominationWindow-bg-open">
                    <span>{{ "open" | translate }}</span>
                </p>
            </div>
        }

        @if (rowData?.nomination_window === "no") {
            <div class="nominationWindow close-width">
                <p class="nominationWindow-bg-close">
                    <span>{{ "closed" | translate }}</span>
                </p>
            </div>
        }

        @if (rowData?.nomination_window === "notStarted") {
            <div class="nominationWindow not-started-width">
                <p class="nominationWindow-bg-not-started">
                    <span>{{ "notStarted" | translate }}</span>
                </p>
            </div>
        }
    }
}

@if (entity === "user_profile") {
    @if (columnDetails?.field === "status") {
        <div
            class="profile-status"
            [class]="{
                inactive: rowData[columnDetails?.field] === 'Inactive',
                approved: rowData[columnDetails?.field] === 'Approved',
                pending: rowData[columnDetails?.field] === 'Pending',
                rejected: rowData[columnDetails?.field] === 'Rejected',
            }"
        >
            <div class="dot"></div>
            <p>{{ rowData[columnDetails?.field] }}</p>
        </div>
    }
    @if (columnDetails?.field === "first_name") {
        <p>{{ (rowData.first_name || "") + " " + (rowData.last_name || "") }}</p>
    }
    @if (columnDetails.field === "application") {
        <p>{{ rowData.application.description | titlecase }}</p>
    }
    @if (columnDetails.field === "role") {
        <p>{{ rowData.role.description | titlecase }}</p>
    }
    @if (columnDetails.field === "_created") {
        <p>{{ rowData._created * 1000 | date: "dd MMM yyyy hh:mm:ss a" }}</p>
    }
    @if (columnDetails.field === "location") {
        <p [innerHTML]="getLocation()"></p>
    }
}

@if (entity === "mobNominationSummary") {}

@if (entity === "stallMemberList") {
    @if (columnDetails?.field === "accommodation") {
        <div class="accomodation">
            @if (rowData?.accommodation === "Yes") {
                <p class="accomodation-bg-yes">
                    <span>{{ rowData.accommodation | translate }}</span>
                </p>
            } @else {
                <p class="accomodation-bg-no">
                    <span>{{ rowData?.accommodation | translate }}</span>
                </p>
            }
        </div>
    }

    @if (columnDetails.field === "idCard") {
        <a type="primary" (click)="componentEvent.emit({ action: { name: 'idCard' }, rowData })">{{ "download" | translate }}</a>
    }
}
@if (entity === "sales-summary") {
    @if (columnDetails.field === "date") {
        <p>{{ getFormattedDate(rowData.date) }}</p>
    }
}

@if (entity === "melaCoordinatorList") {
    @if (columnDetails.field === "accommodation") {
        <div class="accomodation">
            @if (rowData?.accommodation === "Yes") {
                <p class="accomodation-bg-yes">
                    <span>{{ rowData.accommodation | translate }}</span>
                </p>
            } @else {
                <p class="accomodation-bg-no">
                    <span>{{ rowData?.accommodation | translate }}</span>
                </p>
            }
        </div>
    }

    @if (columnDetails.field === "idCard") {
        <a type="primary" (click)="componentEvent.emit({ action: { name: 'idCard' }, rowData })">{{ "download" | translate }}</a>
    }
}
